import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_switch = _resolveComponent("el-switch");
  return _openBlock(), _createBlock(_component_el_switch, {
    modelValue: _ctx.realValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.realValue = $event),
    onChange: _ctx.onChange
  }, null, 8, ["modelValue", "onChange"]);
}